// /src/Components/Domain/components/DeploymentResult.jsx

import React from "react";
import {
  CheckCircle2,
  Copy,
  ExternalLink,
} from "lucide-react";

export default function DeploymentResult({
  createdDomainData,
  finalUrl,
  onCopyDomain,
  onCopyFinalUrl,
}) {
  if (!createdDomainData) return null;

  return (
    <div className="mt-4 overflow-hidden rounded-2xl border border-emerald-200 bg-emerald-50">
      <div className="border-b border-emerald-100 bg-white/70 px-4 py-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-emerald-700">
          <CheckCircle2 size={18} />
          Deployment Completed Successfully
        </div>
      </div>

      <div className="p-4">
        <div className="flex flex-col justify-between gap-4 lg:flex-row lg:items-start">
          <div className="min-w-0 flex-1">
            <h3 className="break-all font-mono text-base font-semibold text-gray-900">
              {createdDomainData.fullDomain}
            </h3>

            <p className="mt-1 text-sm text-gray-600">
              DNS, cPanel, template deployment and manifest sync
              completed successfully.
            </p>

            <div className="mt-3 grid grid-cols-1 gap-2 md:grid-cols-2 xl:grid-cols-5">
              <ResultItem
                label="Client"
                value={createdDomainData.selectedClientId}
              />

              <ResultItem
                label="Host"
                value={createdDomainData.dynamicHost}
              />

              <ResultItem
                label="IP"
                value={createdDomainData.ip}
              />

              <ResultItem
                label="Template"
                value={createdDomainData.template}
              />

              <ResultItem
                label="Template ID"
                value={createdDomainData.templateid}
              />
            </div>

            <div className="mt-3 rounded-xl border border-emerald-100 bg-white px-3 py-2">
              <p className="text-xs font-semibold text-gray-400">
                Final Live URL
              </p>

              <div className="mt-1 flex flex-wrap items-center gap-2">
                <p className="break-all font-mono text-xs font-semibold text-emerald-700">
                  {finalUrl}
                </p>

                <button
                  type="button"
                  onClick={onCopyFinalUrl}
                  className="inline-flex items-center gap-1 rounded-lg border bg-white px-2 py-1 text-xs font-semibold text-gray-600 hover:bg-gray-50"
                >
                  <Copy size={12} />
                  Copy
                </button>

                <a
                  href={finalUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1 rounded-lg border bg-white px-2 py-1 text-xs font-semibold text-gray-600 hover:bg-gray-50"
                >
                  <ExternalLink size={12} />
                  Open
                </a>
              </div>
            </div>
          </div>

          <button
            type="button"
            onClick={onCopyDomain}
            className="inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-xl border bg-white px-4 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            <Copy size={15} />
            Copy Domain
          </button>
        </div>
      </div>
    </div>
  );
}

function ResultItem({ label, value }) {
  return (
    <div className="rounded-lg border border-emerald-100 bg-white px-3 py-2">
      <p className="text-xs font-semibold text-gray-400">
        {label}
      </p>

      <p className="mt-0.5 break-all font-mono text-xs font-semibold text-gray-800">
        {value || "—"}
      </p>
    </div>
  );
}